import { useEffect, useRef } from 'react';
import { useData } from 'hooks/useData';
import TiraRanking from 'components/3catinfo/TiraRanking';
import NotFound from 'components/3catinfo/NotFound';
import Audiencies from 'components/3catinfo/Audiencies';
import MenuError from 'components/3catinfo/MenuError';
import Peu from 'components/3catinfo/Peu/Peu';
import Fila from 'components/3catinfo/Fila/Fila';

const Error = (props) => {
    const { statusCode } = props;
    const tiraRef = useRef(null);

    const urlMesLlegit =
        '%%dataResources.apiCCMA%%/noticies?_format=json&origen=rankings&feed=noticies-324-tempslectura-24h&items_pagina=5&pagina=1&sdom=img&version=2.0&cache=180&https=true&master=yes&perfils_extra=imatges_3catinfo';
    const { data: itemsMesLlegit, getDades: getDadesMesLlegit } = useData();

    useEffect(() => {
        getDadesMesLlegit(urlMesLlegit);

        const handleTiraRankingClick = (e) => {
            if (tiraRef?.current?.contains(e.target)) {
                const link = e.target.closest('a');
                if (link?.href) {
                    const href = link.getAttribute('href');
                    if (href.startsWith('/')) {
                        e.preventDefault();
                        window.location.href = href;
                    }
                }
            }
        };

        document.addEventListener('click', handleTiraRankingClick);

        return () => {
            document.removeEventListener('click', handleTiraRankingClick);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Audiencies tipus='errorPage' />
            <div>
                <MenuError />
                <div className='centrat'>
                    <NotFound code={statusCode} text='Ho sentim, no trobem el que busques' />
                </div>
                <Fila tipus='fixed' estil='slider'>
                    {itemsMesLlegit && (
                        <span ref={tiraRef}>
                            <TiraRanking
                                titol='Explora les notícies més llegides'
                                titolClass='ranking'
                                estil='slider'
                                tipus='fixed'
                                items={itemsMesLlegit}
                                routePath='web_actualitat_item_noticia'
                                numColumnsRow='12'
                                moduleName='TiraRanking'
                                isRanking={true}
                            />
                        </span>
                    )}
                </Fila>
                <Peu />
            </div>
        </>
    );
};

export default Error;
